import { Component, computed, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { nullish } from '@nestech/utils';
import { EnvironmentService, MemberStore, NotificationStore } from '@web/service';

const getIcons = (environmentService: EnvironmentService) =>
  environmentService.environment.header?.profileIcon ?? {
    male: ['fas', 'user-hair'],
    female: ['fas', 'user-hair-long'],
    other: ['fas', 'user-hair-mullet'],
  };

const getGender = (socialIdentifier: string | nullish) =>
  socialIdentifier ? (parseInt(socialIdentifier.slice(-1)) % 2 === 0 ? 'female' : 'male') : 'other';

@Component({
  selector: 'cas-top-navigation-profile',
  template: `
    <a
      class="d-flex btn align-items-center position-relative"
      routerLink="/profile">
      <fa-icon
        class="bg-primary text-cloud-white p-1 rounded-circle"
        [icon]="icon()"
        size="lg"
        [fixedWidth]="true"></fa-icon>
      <span class="d-none d-md-inline ms-2">{{ firstName() }}</span>
      @if (hasNotifications()) {
        <div class="bullet bg-danger"></div>
      }
    </a>
  `,
  styles: [
    `
      div.bullet {
        position: absolute;
        height: 12px;
        width: 12px;
        left: 35px;
        top: 4px;
        border-radius: 50%;
        border: 2px solid #fff;
      }
    `,
  ],
  imports: [FontAwesomeModule, RouterLink],
})
export class TopNavigationProfileComponent {
  #notificationStore = inject(NotificationStore);
  #member = inject(MemberStore).member.value;
  #environment = inject(EnvironmentService);

  firstName = computed(() => {
    return this.#member()?.firstName ?? '';
  });
  icon = computed(() => getIcons(this.#environment)[getGender(this.#member()?.socialIdentifier)]);

  hasNotifications = computed(() => this.#notificationStore.notifications().some(n => n.id.startsWith('MISSING_')));
}
